export default __webpack_public_path__ + "static/media/404-error.720052b2.png";